import { motion, useReducedMotion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';

export default function Reveal({ children, delay = 0, y = 28, className = '' }) {
  const reduce = useReducedMotion();
  const ref = useRef(null);
  const [forced, setForced] = useState(false);

  // Fail-safe: if the element is in view but its entrance animation never ran
  // (background/throttled tab), force it visible so a page can never stay blank.
  useEffect(() => {
    if (reduce || forced) return undefined;
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') return undefined;
    let timer;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          clearTimeout(timer);
          timer = setTimeout(() => {
            if (+getComputedStyle(el).opacity < 0.05) setForced(true);
          }, 1500 + delay * 1000);
        }
      });
    });
    io.observe(el);
    return () => {
      clearTimeout(timer);
      io.disconnect();
    };
  }, [reduce, forced, delay]);

  if (reduce || forced) {
    return <div className={className}>{children}</div>;
  }
  return (
    <motion.div
      ref={ref}
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}
